import { render, staticRenderFns } from "./work_order_page.vue?vue&type=template&id=e192b044&scoped=true"
import script from "./work_order_page.vue?vue&type=script&lang=js"
export * from "./work_order_page.vue?vue&type=script&lang=js"
import style0 from "./work_order_page.vue?vue&type=style&index=0&id=e192b044&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e192b044",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\2026\\Halov2-Fishery-Upgrade\\halov-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e192b044')) {
      api.createRecord('e192b044', component.options)
    } else {
      api.reload('e192b044', component.options)
    }
    module.hot.accept("./work_order_page.vue?vue&type=template&id=e192b044&scoped=true", function () {
      api.rerender('e192b044', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cms/work_order_page.vue"
export default component.exports